import Vue from 'vue';

const success = (context, response) => {
  context.users = response.data.user;
  context.users.engine_link = `${window.location.protocol}${process.env.API_URL}/#/get-available-rentals/${context.users.web_key}`;
  if (!context.users.setting) {
    context.users.setting = {};
  }
  if (!context.users.setting.use_own_email_address) {
    context.users.setting.use_own_email_address = 'no';
  }
  if (response.data.user.super_checkin_account) {
    context.superCheckin.id = response.data.user.super_checkin_account.id;
    context.superCheckin.superCheckinUsername = response.data.user.super_checkin_account.username;
    context.superCheckin.superCheckinPassword = response.data.user.super_checkin_account.password;
  } else {
    context.superCheckin.id = null;
    context.superCheckin.superCheckinUsername = null;
    context.superCheckin.superCheckinPassword = null;
  }
  if (context.superCheckin) {
    context.superCheckin.loading = false;
  }

  context.isNukiConnected = !!context.users.setting.nuki_api_key;
  context.nukiApiKey = context.users.setting.nuki_api_key;
  context.isIgloohomeConnected = !!context.users.setting.igloohome_api_key;
  context.igloohomeApiKey = context.users.setting.igloohome_api_key;
  context.isTheKeysConnected = !!context.users.setting.the_key_username;
  context.theKeys = {
    username: context.users.setting.the_key_username,
    password: context.users.setting.the_key_password,
  };
  context.countries = response.data.countries;
  context.currencies = response.data.currencies;
};

const failed = () => {
};

export default context => Vue.$http.get('/account').then((response) => {
  if (response && response.status === 200) {
    success(context, response);
  }
});



// WEBPACK FOOTER //
// ./src/app/services/account/fetchAccount.js